import { render, staticRenderFns } from "./add-research-site.vue?vue&type=template&id=4c88c9e5&scoped=true&"
import script from "./add-research-site.vue?vue&type=script&lang=js&"
export * from "./add-research-site.vue?vue&type=script&lang=js&"
import style0 from "./add-research-site.vue?vue&type=style&index=0&id=4c88c9e5&scoped=true&lang=scss&"
import style1 from "./add-research-site.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c88c9e5",
  null
  
)

component.options.__file = "add-research-site.vue"
export default component.exports